import styled from 'styled-components';
import { AIframeAspectRatio } from './AIframe.types';

const getAspectRatioValue = (ratio: AIframeAspectRatio): string => ratio.replace(':', ' / ');

export const Wrapper = styled.div<{ $aspectRatio: AIframeAspectRatio }>`
  position: relative;
  inline-size: 100%;
  aspect-ratio: ${({ $aspectRatio }) => getAspectRatioValue($aspectRatio)};
  overflow: hidden;
`;

export const IframeElement = styled.iframe`
  display: block;
  inline-size: 100%;
  block-size: 100%;
  border: 0;
`;
